import React, { useMemo } from 'react';
import { Tabs } from '@/components/molecules/Tabs';
import { PageTab, useDashboard, usePageActions, Widget } from '@/modules';
import classNames from 'classnames';
import { getPageDisplayTitle } from '@/modules/pages/utils/products';

interface PageTabsProps {
    tabs: PageTab[];
    widgets: Widget[];
    currentTab: PageTab | null;
}

const PageTabs = ({ tabs: _tabs, currentTab }: PageTabsProps) => {
    const { state: { dealerContractedProducts } } = useDashboard();
    const tabs = useMemo(() => {
        return _tabs.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0)).map((tab) => ({
            id: tab.id,
            value: tab.id,
            label: getPageDisplayTitle(tab.metadata?.['tab-titles'], dealerContractedProducts?.contractedProducts) ?? tab.title,
            icon: tab.icon,
            disabled: tab.disabled,

        }));
    }, [_tabs]);
    const { setCurrentTab } = usePageActions();


    return (
        <div className={classNames('mb-2', 'p-4')}>
            <Tabs fullWidth value={currentTab?.id || (tabs?.[0].id ?? null)} onChange={(tabId) => {
                const selectedTab = _tabs.find(t => t.id === tabId) as PageTab | undefined;
                setCurrentTab(selectedTab || null);
            }} items={tabs} />
        </div>
    )
}

export { PageTabs }